import {
  NEWDANHMUCDANGKIEM_COUNT_ASSIGN_SUCCESS,
  NEWDANHMUCDANGKIEM_HISTORY_LIST_SUCCESS,
  NEWDANHMUCDANGKIEM_IMPORT_SUCCESS,
  NEWDANHMUCDANGKIEM_LIST_SUCCESS,
  NEWDANHMUCDANGKIEM_NEW_CARE_SUCCESS,
  NEWDANHMUCDANGKIEM_ONE_SUCCESS,
  NEWDANHMUCDANGKIEM_UPDATE_FILTER,
  NEWDANHMUCDANGKIEM_SAVE_SUCCESS,
  NEWDANHMUCDANGKIEM_UPDATE_HOMEPAGE_FILTER,
  NEWDANHMUCDANGKIEM_HOMEPAGE_LIST_SUCCESS,
  NEWDANHMUCDANGKIEM_HOMEPAGE_ONE_SUCCESS,
  NEWDANHMUCDANGKIEM_HANDLE_IMPORT_ERRORS,
} from 'src/actions/newdanhmucdangkiem.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

const initState = {
  filter: {
    so_dien_thoai: '',
    loai_sim: {},
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  homepageNewdanhmucdangkiemFilter: {
    so_dien_thoai: '',
    loai_sim: {},
    homepageNewdanhmucdangkiemPage: 0,
    homepageNewdanhmucdangkiemLimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  selected: undefined,
  homepageNewdanhmucdangkiemItems: [],
  homepageNewdanhmucdangkiemTotal: 0,
  homepageNewdanhmucdangkiemSelected: undefined,
  temp: [],
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0,
  temp_upgoicuoc: [],
  errorRows: {},
}

const newdanhmucdangkiemReducer = (state = initState, action) => {
  switch (action.type) {
    case NEWDANHMUCDANGKIEM_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case NEWDANHMUCDANGKIEM_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case NEWDANHMUCDANGKIEM_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case NEWDANHMUCDANGKIEM_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageNewdanhmucdangkiemFilter !== 'undefined' && state.homepageNewdanhmucdangkiemFilter) {
        if (action.data.homepageNewdanhmucdangkiemPage == 'no_update' && typeof state.homepageNewdanhmucdangkiemFilter.homepageNewdanhmucdangkiemPage !== 'undefined') action.data.homepageNewdanhmucdangkiemPage = state.homepageNewdanhmucdangkiemFilter.homepageNewdanhmucdangkiemPage;
        if (action.data.homepageNewdanhmucdangkiemLimit == 'no_update' && typeof state.homepageNewdanhmucdangkiemFilter.homepageNewdanhmucdangkiemLimit !== 'undefined') action.data.homepageNewdanhmucdangkiemLimit = state.homepageNewdanhmucdangkiemFilter.homepageNewdanhmucdangkiemLimit;
      }
      return {
        ...state,
        homepageNewdanhmucdangkiemFilter: action.data,
      }
    }
    case NEWDANHMUCDANGKIEM_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageNewdanhmucdangkiemItems: action.data.homepageNewdanhmucdangkiemItems,
        homepageNewdanhmucdangkiemTotal: action.data.homepageNewdanhmucdangkiemTotal,
      }
    }
    case NEWDANHMUCDANGKIEM_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageNewdanhmucdangkiemSelected: action.data
      }
    }
    case NEWDANHMUCDANGKIEM_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case NEWDANHMUCDANGKIEM_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case NEWDANHMUCDANGKIEM_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case NEWDANHMUCDANGKIEM_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    case NEWDANHMUCDANGKIEM_SAVE_SUCCESS: {
      return {
        ...state,
        temp_upgoicuoc: []
      }
    }
    case NEWDANHMUCDANGKIEM_HANDLE_IMPORT_ERRORS: {
      return {
        ...state,
        errorRows: action.data,
      }
    }
    default: {
      return state;
    }
  }
}
export default newdanhmucdangkiemReducer